import type { IContactPersonEmploymentCode } from './ContactPersonEmploymentCode.interface';

export default class ContactPersonEmploymentCode implements IContactPersonEmploymentCode {
  id: string;
  value: string;

  static build = (data: IContactPersonEmploymentCode) => new ContactPersonEmploymentCode(data);
  static blank = () => new ContactPersonEmploymentCode();

  /**
   * Constructor
   * @param {IContactPersonEmploymentCode} data
   */
  constructor(data?: IContactPersonEmploymentCode) {
    this.id = data?.id || undefined;
    this.value = data?.value || undefined;
  }
}
